/**
 * @file TransferRow.tsx
 * @description Строка сотрудника в «Передать диалог» (chat-window-design.md
 * §1д, §4): инициалы 32, имя 14/500, роль 12, справа «N диалогов» и метка
 * выбора; нынешний ответственный неактивен — «ведёт сейчас». Высота 56.
 */

import { cn } from "@/lib/utils";
import type { TransferCandidate } from "../../lib/api-chat";
import { initials } from "./chat-format";
import { CHAT_TEXT } from "./chat-texts";

interface Props {
  candidate: TransferCandidate;
  chosen: boolean;
  onChoose: () => void;
}

export function TransferRow({ candidate, chosen, onChoose }: Props) {
  const current = candidate.isCurrentAssignee;
  return (
    <button
      type="button"
      role="radio"
      aria-checked={chosen}
      disabled={current}
      onClick={onChoose}
      className={cn(
        "flex min-h-14 w-full items-center gap-3 rounded-lg px-2 text-left outline-none",
        "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-60",
        chosen ? "bg-accent" : "hover:bg-surface-low",
      )}
    >
      <span aria-hidden className="inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-surface-low text-xs font-semibold text-on-surface">
        {initials(candidate.name)}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-medium text-on-surface">{candidate.name}</span>
        <span className="truncate text-xs text-on-surface-variant">{candidate.roleName}</span>
      </span>
      <span className="shrink-0 text-xs text-on-surface-variant">
        {current ? CHAT_TEXT.transferCurrent : CHAT_TEXT.conversationsCount(candidate.openConversations)}
      </span>
      <span
        aria-hidden
        className={cn(
          "inline-flex size-5 shrink-0 items-center justify-center rounded-full",
          "[box-shadow:inset_0_0_0_1.5px_var(--outline-variant)]",
          chosen && "[box-shadow:inset_0_0_0_6px_var(--primary)]",
        )}
      />
    </button>
  );
}
